import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdminReportComponent } from './admin-report.component';
import { SharedModule } from '@shared/shared.module';
import {
    AdminReportCreateComponent,
    AdminReportEditComponent,
    AdminReportListComponent
} from '@app/main/admin/modules/admin-report/components';

@NgModule({
    declarations: [
        AdminReportComponent,
        AdminReportListComponent,
        AdminReportCreateComponent,
        AdminReportEditComponent
    ],
    exports: [AdminReportComponent],
    imports: [CommonModule, SharedModule]
})
export class AdminReportModule {}
